import { render, staticRenderFns } from "./ContactpersonDialog.vue?vue&type=template&id=fc0963ac&"
import script from "./ContactpersonDialog.vue?vue&type=script&lang=js&"
export * from "./ContactpersonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports